// src/utils/timeEntryFields.js
// Leitet die editierbaren Formularfelder (Projekt/Aktivitaet/Beschreibung) aus
// einem bestehenden Zeiteintrag ab. Genutzt sowohl beim Oeffnen der
// Bearbeitung (TimeEntryForm) als auch beim Verschieben/Groessenaendern per
// Drag im Kalender (useTimeTracking.adjustTimeEntry), damit beide Wege
// dieselben Felder aus einem Eintrag gleich befuellen.
export const deriveEntryFields = (entry, activityTypes) => {
  const matchedType = (activityTypes || []).find(
    (at) =>
      at.translations?.de?.description?.toLowerCase() ===
      (entry.typeName || "").toLowerCase()
  );
  return {
    activityTypeUuid: matchedType?.uuid || "",
    description: entry.description || entry.comment || "",
    contractUuid: entry.contractUuid || "",
    localProjectCode: entry.code || "",
    localProjectName: entry.contractTitle || entry.contractNoteName || "",
  };
};
